import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('chroa-button-pub-priv', (fragmentElement, configuration, meta) => {
});

if (import.meta.hot) {
    import.meta.hot.accept();
}
